/**	MARK: Machine Schemas
	============================================
 **/

// import * as bson from 'bson-objectid';


export const MachineStatus = {
	"Pending"	:"Pending",
	"Train"		:"Train", // About to train
	"InProcess"	:"InProcess", // Training - Predicting
	"InTraining":"InTraining",
	"Completed"	:"Completed",
	"StandBy"	:"StandBy",
	"Ready"		:"Ready"
	
};

export const MachineSignal = { "Train":"Train", "Predict":"Predict", "Stop":"Stop" };

export const MachineTemplate = {
	"BlankModel": { name: "Blank Model", type:"Custom" },
	"CustomDemandForecast": { name: "Custom demand forecast", type:"Custom" },
	"CustomChurnPrediction": { name: "Custom churn prediction", type:"Custom" },
	"CustomHousePricing": { name: "Custom house pricing", type:"Custom" },
	"DemandForecast": { name: "Demand forecast", type:"Ready" },
	"ChurnPrediction": { name: "Churn prediction", type:"Ready" },
	"HousePricing": { name: "House pricing", type:"Ready" } 
}

export const MachineType = {
	"Custom" : "Custom",
	"Ready"  : "Ready"
}

class MachineStats {
	constructor(){
		this.loss			= 0;
		this.epochs			= 1000;
		this.learning_rate	= 0.01;
		this.learning_limit	= 0.0001;
	}
}

class TimeStats {
	constructor(){
		this.window_analysis 	= 30;
		this.lag_period			= 10;
	}
}


export const FormatBytes = ( (bytes, decimals=2) => {
	if (!+bytes) return '0 Bytes'
		const k = 1024
		const dm = decimals < 0 ? 0 : decimals
		const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
		const i = Math.floor(Math.log(bytes) / Math.log(k))
		return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
});

export class Machine {
	constructor(name, dataset=""){
		//this._id		= bson().toString();
		this.name 		= name;
		this.dataset 	= dataset;
		this.algorithm	= "linear";
		this.y_label	= "";
		this.data		= "";
		this.synthetic_datasets = [];
		this.model		= "";
		this.model_name	= "";
		this.template	= MachineTemplate.BlankModel;
		this.stats 		= new MachineStats()
		this.status		= MachineStatus.Pending;
		this.ts			= new Date();
	}
}
